import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1C1917] text-white" data-testid="footer">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-[#14532D] rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-lg font-serif">E</span>
              </div>
              <div>
                <h3 className="text-lg font-bold font-serif">The Elizabethan Centre</h3>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold font-serif mb-6">Quick Links</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="text-[#A8A29E] hover:text-white transition-colors text-sm">
                Home
              </Link>
              <Link to="/about" className="text-[#A8A29E] hover:text-white transition-colors text-sm">
                About the Hall
              </Link>
              <Link to="/events" className="text-[#A8A29E] hover:text-white transition-colors text-sm">
                Events Calendar
              </Link>
              <Link to="/book" className="text-[#A8A29E] hover:text-white transition-colors text-sm">
                Book the Hall
              </Link>
              <Link to="/contact" className="text-[#A8A29E] hover:text-white transition-colors text-sm">
                Contact Us
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold font-serif mb-6">Contact</h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <MapPin size={18} className="text-[#D97706] mt-0.5 flex-shrink-0" />
                <p className="text-[#A8A29E] text-sm">
                  The Elizabethan Centre<br />
                  Whaplode Drove<br />
                  Spalding, Lincolnshire
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={18} className="text-[#D97706] flex-shrink-0" />
                <a href="tel:01406709653" className="text-[#A8A29E] hover:text-white transition-colors text-sm">
                  01406 709653
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={18} className="text-[#D97706] flex-shrink-0" />
                <a href="mailto:elizabethancentre@gmail.com" className="text-[#A8A29E] hover:text-white transition-colors text-sm">
                  elizabethancentre@gmail.com
                </a>
              </div>
            </div>
          </div>

          {/* Opening Hours */}
          <div>
            <h4 className="text-lg font-semibold font-serif mb-6">Opening Hours</h4>
            <div className="flex items-start gap-3">
              <Clock size={18} className="text-[#D97706] mt-0.5 flex-shrink-0" />
              <div className="text-[#A8A29E] text-sm">
                <p className="mb-2"><span className="text-white">Wednesday:</span> 7:30pm - 11:30pm</p>
                <p className="mb-2"><span className="text-white">Thursday:</span> 7:30pm - 11:30pm</p>
                <p className="mb-2"><span className="text-white">Friday:</span> 7:30pm - 12am</p>
                <p className="mb-2"><span className="text-white">Saturday:</span> 12pm - 12am</p>
                <p><span className="text-white">Sunday:</span> 12pm - 3pm</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#292524]">
        <div className="container-custom py-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-[#78716C] text-sm">
            © {currentYear} The Elizabethan Centre, Whaplode Drove. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/contact" className="text-[#78716C] hover:text-white transition-colors text-sm">
              Privacy Policy
            </Link>
            <Link to="/contact" className="text-[#78716C] hover:text-white transition-colors text-sm">
              Terms of Hire
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
